<template>
    <div class="tw-w-full">
        <div
            class="tw-leading-none tw-mb-3 tw-bg-red-50 tw-rounded-lg tw-p-2 tw-py-3"
            v-if="error_message.length > 0"
        >
            <div class="tw-flex tw-items-center tw-mb-2">
                <i
                    class="fas fa-exclamation-triangle tw-text-red-500 tw-text-md tw-ml-2 tw-mr-2"
                ></i>
                <span
                    class="tw-text-sm tw-text-red-600"
                    v-text="error_message"
                ></span>
            </div>

            <!-- Re-Verify Button -->
            <button
                v-if="verify.show_verify_button"
                @click.prevent="onReVerify"
                class="btn btn-sm tw-bg-main-color tw-text-white tw-py-1 tw-text-xs tw-ml-[34px]"
            >
                <BeatLoader
                    v-if="re_verifying"
                    :loading="re_verifying"
                    color="white"
                    size="7px"
                    class="tw-pt-[3px]"
                ></BeatLoader>
                <span v-else>Verify</span>
            </button>

            <!-- Re-Activate Button -->
            <button
                v-if="re_activate.show_reactivate_button"
                @click.prevent="onReActivate"
                class="btn btn-sm tw-bg-main-color tw-text-white tw-py-1 tw-text-xs tw-ml-[34px]"
            >
                <BeatLoader
                    v-if="re_activating"
                    :loading="re_activating"
                    color="white"
                    size="7px"
                    class="tw-pt-[3px]"
                ></BeatLoader>
                <span v-else>Re-Activate</span>
            </button>
        </div>
        <div v-show="form.login_type == 'phone'" class="form-group tw-mb-5">
            <div class="tw-relative">
                <div
                    class="tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-left-3 tw-text-black"
                >
                    <Select2
                        v-model="form.selected_country_code"
                        :options="$page.props.country_dial_codes.codes"
                        :settings="{
                            templateSelection: selectedFormat,
                        }"
                        @change="myChangeEvent($event)"
                        @select="mySelectEvent($event)"
                        id="loginPhoneInput"
                    />
                </div>
                <input
                    type="text"
                    class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg phone-number-input"
                    :placeholder="__('chat.phone_number')"
                    @keypress="inputValidate"
                    @focus="
                        input_errors.phone = '';
                        show_switch = false;
                    "
                    @focusout="show_switch = true"
                    v-model="form.phone"
                />
                <span
                    v-if="show_switch"
                    @click="changeLoginType('email')"
                    v-btooltip:top="__('chat.login_with_email')"
                    class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                >
                    <i class="fas fa-angle-right tw-text-sm"></i>
                    <i class="fas fa-envelope tw-text-sm"></i>
                </span>
            </div>
            <span
                class="tw-text-red-500 tw-absolute tw-px-2 tw-text-xs"
                v-if="input_errors.phone"
                v-text="input_errors.phone[0]"
            ></span>
        </div>
        <div v-show="form.login_type == 'email'" class="form-group tw-mb-5">
            <div class="tw-relative">
                <input
                    type="email"
                    class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                    :placeholder="__('chat.email_address')"
                    @focus="
                        input_errors.email = '';
                        show_switch = false;
                    "
                    @focusout="show_switch = true"
                    v-model="form.email"
                />
                <span
                    v-if="show_switch"
                    @click="changeLoginType('phone')"
                    v-btooltip:top="__('chat.login_with_phone')"
                    class="tw-cursor-pointer tw-text-black/50 hover:tw-text-black tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-bg-white tw-px-3 tw-py-1 tw-rounded-lg tw-right-[10px] tw-text-black"
                >
                    <i class="fas fa-angle-right tw-text-sm"></i>
                    <i class="fas fa-phone tw-text-sm"></i>
                </span>
            </div>
            <span
                class="tw-text-red-500 tw-absolute tw-px-2 tw-text-xs"
                v-if="input_errors.email"
                v-text="input_errors.email[0]"
            ></span>
        </div>
        <div class="form-group tw-mb-5">
            <div class="tw-relative">
                <input
                    :type="show_password ? 'text' : 'password'"
                    class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                    :placeholder="__('chat.password')"
                    @focus="input_errors.password = ''"
                    v-model="form.password"
                />
                <span
                    v-if="form.password.length"
                    @click="show_password = !show_password"
                    class="tw-absolute tw-cursor-pointer tw-top-[50%] tw-text-slate-500 tw-translate-y-[-50%] tw-right-4"
                    ><i v-if="show_password" class="fas fa-eye-slash"></i>
                    <i v-else class="far fa-eye"></i
                ></span>
            </div>
            <span
                class="tw-text-red-500 tw-absolute tw-px-2 tw-text-xs"
                v-if="input_errors.password"
                v-text="input_errors.password[0]"
            ></span>
        </div>
        <div class="tw-w-full">
            <div
                class="tw-flex tw-justify-between tw-px-[6px] tw-my-2 tw-items-center"
            >
                <div class="form-check tw-mb-0 tw-mr-1">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="rememberMe"
                        v-model="form.remember"
                        :checked="form.remember"
                    />
                    <label class="form-check-label tw-text-sm" for="rememberMe">
                        {{ __("chat.keep_me") }}
                    </label>
                </div>
                <span
                    data-bs-toggle="modal"
                    data-bs-target="#forgotPasswordFormModal"
                    class="tw-text-sm tw-cursor-pointer hover:tw-underline tw-text-main-color"
                    >{{ __("chat.forgotten_password") }}</span
                >
            </div>
            <button
                @click.prevent="login"
                class="btn tw-h-[45px] tw-w-full btn-md tw-rounded-lg tw-text-white tw-bg-main-color"
            >
                <BeatLoader
                    v-if="logging_in"
                    :loading="logging_in"
                    color="white"
                    size="7px"
                    class="tw-pt-[3px]"
                ></BeatLoader>
                <span v-else>{{ __("chat.login") }}</span>
            </button>
            <!-- <button
                type="button"
                @click.prevent="viewLoginForm('starfish_login')"
                class="btn tw-mt-2 tw-h-[45px] tw-w-full btn-md tw-rounded-lg tw-text-white tw-border-[#38cf69] tw-bg-[#38cf69]"
            >
                <img
                    :src="
                        require('../../../assets/landing/img/starfish_borderless_logo.png')
                    "
                    class="tw-h-[20px] tw-mr-1 tw-rounded-[5px]"
                    alt=""
                />
                Login with Starfish
            </button> -->
        </div>
    </div>
</template>

<script>
import { generalStore } from "@landing/Stores/general_store";
import { login, resendOtp } from "@landing/Services/auth_service";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";

export default {
    components: { BeatLoader },
    data() {
        return {
            generalStore: generalStore(),
            show_password: false,
            form: {
                selected_dial_code: "",
                selected_country_code: "",
                phone: "",
                email: "",
                password: "",
                remember: false,
                login_type: "email",
            },
            input_errors: {},
            error_message: "",
            logging_in: false,
            re_verifying: false,
            re_activating: false,
            show_switch: true,
            verify: {
                show_verify_button: false,
                type: "",
                value: "",
            },
            re_activate: {
                show_reactivate_button: false,
                type: "",
                value: "",
            },
        };
    },
    mounted() {
        this.form.selected_country_code =
            this.$page.props.country_dial_codes.current.country_code;
        this.form.selected_dial_code =
            this.$page.props.country_dial_codes.current.dial_code;

        this.select2InputStyle(this.form.selected_dial_code);
    },
    methods: {
        selectedFormat() {
            return this.form.selected_dial_code;
        },
        myChangeEvent(val) {
            this.select2InputStyle(val);
        },
        mySelectEvent({ id, text }) {
            const regex = /\((\+\d+)\)/;
            const match = text.match(regex);
            if (match && match.length > 1) {
                this.form.selected_dial_code = match[1];
            }

            this.select2InputStyle(this.form.selected_dial_code);
        },
        select2InputStyle(val) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "15px Arial";
            var metrics = context.measureText(val);
            let input = document.querySelector(".phone-number-input");
            input.style.paddingLeft = Math.ceil(metrics.width) + 18 + "px";
        },
        login() {
            this.logging_in = true;
            this.verify = {};
            login(this.form).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200 && data.status != 422) {
                    this.input_errors = {};
                    this.error_message = "Oops! Something went wrong.";
                } else if (data.status == 200) {
                    this.input_errors = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        Vue.$toast.success(data.data.message);
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        if ("re_verify" in data.data.data) {
                            this.verify.show_verify_button = true;
                            this.verify.type = data.data.data.type;
                            this.verify.value = data.data.data.value;
                        }
                        if ("re_activate" in data.data.data) {
                            this.re_activate.show_reactivate_button = true;
                            this.re_activate.type = data.data.data.type;
                            this.re_activate.value = data.data.data.value;
                        }

                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.logging_in = false;
                }, 500);
            });
        },
        onReVerify() {
            this.re_verifying = true;
            resendOtp({
                type: this.verify.type,
                value: this.verify.value,
            }).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.verify = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.viewLoginForm("re_verify", data.data);
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.re_verifying = false;
                }, 500);
            });
        },
        onReActivate() {
            this.re_activating = true;
            resendOtp({
                type: this.re_activate.type,
                value: this.re_activate.value,
            }).then((data) => {
                if (data.status == 422) {
                    this.error_message = "";
                    this.input_errors = data.data.errors;
                } else if (data.status != 200) {
                    this.error_message = this.__("chat.something_wrong");
                } else if (data.status == 200) {
                    this.verify = {};
                    this.error_message = "";
                    if (data.data.result == 1) {
                        this.viewLoginForm("re_activate", data.data);
                    } else {
                        this.error_message = data.data.message;
                    }
                }

                setTimeout(() => {
                    this.re_activating = false;
                }, 500);
            });
        },
        inputValidate(evt) {
            var theEvent = evt || window.event;

            if (theEvent.code == "Enter") {
                return;
            }
            // Handle paste
            if (theEvent.type === "paste") {
                key = event.clipboardData.getData("text/plain");
            } else {
                // Handle key press
                var key = theEvent.keyCode || theEvent.which;
                key = String.fromCharCode(key);
            }
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        },
        viewLoginForm(val, data = null) {
            this.generalStore.setActiveLoginForm(val, data);
        },
        changeLoginType(val) {
            this.form.login_type = val;
        },
    },
};
</script>
